import GuideParagrafoDetails from './GuideParagrafoDetails';

export default GuideParagrafoDetails;
